import script from "./EmployeesWithAbsences.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesWithAbsences.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesWithAbsences.vue?vue&type=style&index=0&id=9eb5ca06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9eb5ca06"]])

export default __exports__